var React = require('react');

function SmFbInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.3998 9.2H8.3998L9.1998 6H6.3998V4.4C6.3998 3.576 6.3998 2.8 7.9998 2.8H9.1998V0.112C8.939 0.0776001 7.9542 0 6.9142 0C4.7422 0 3.1998 1.3256 3.1998 3.76V6H0.799805V9.2H3.1998V16H6.3998V9.2Z"}));
}

SmFbInline.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = SmFbInline;

SmFbInline.default = SmFbInline;
